import React from "react";
import { Menu } from "@headlessui/react";
import { useTranslation } from "react-i18next";
import Flag from "react-flagkit";
import { GlobeAltIcon } from "@heroicons/react/24/outline";

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    // No need to navigate - just change the language, stay on the same route
  };

  return (
    <Menu as="div" className="relative items-center">
      <Menu.Button
        className="nav-link"
        title="Change Language"
        aria-label={t("language_switcher.aria_label")}
      >
        <GlobeAltIcon className="h-7 w-7" aria-hidden="true" />
      </Menu.Button>
      <Menu.Items className="absolute right-0 mt-2 w-52 origin-top-right bg-white border border-gray-300 divide-y divide-gray-100 rounded-md shadow-lg outline-none z-50">
        <Menu.Item>
          {({ active }) => (
            <button
              className={`${
                active ? "bg-blue text-black" : "text-gray-900"
              } group flex rounded-md items-center w-full px-2 py-2 text-sm ${
                i18n.language === "en" ? "font-bold" : ""
              }`}
              onClick={() => changeLanguage("en")}
            >
              <Flag country="GB" size={20} className="mr-2" />
              English
            </button>
          )}
        </Menu.Item>
        <Menu.Item>
          {({ active }) => (
            <button
              className={`${
                active ? "bg-blue text-black" : "text-gray-900"
              } group flex rounded-md items-center w-full px-2 py-2 text-sm ${
                i18n.language === "sv" ? "font-bold" : ""
              }`}
              onClick={() => changeLanguage("sv")}
            >
              <Flag country="SE" size={20} className="mr-2" />
              Svenska
            </button>
          )}
        </Menu.Item>
      </Menu.Items>
    </Menu>
  );
};

export default LanguageSwitcher;
